var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Search_svg__a)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.67 16.51-3.51-3.5.85-.85 3.5 3.51-.84.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02 14.55c-3.05 0-5.53-2.48-5.53-5.53 0-3.05 2.48-5.53 5.53-5.53 3.05 0 5.53 2.48 5.53 5.53 0 3.05-2.48 5.53-5.53 5.53Zm0-9.86c-2.39 0-4.33 1.94-4.33 4.33s1.94 4.33 4.33 4.33 4.33-1.94 4.33-4.33-1.94-4.33-4.33-4.33Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.49 3.49)",
    d: "M0 0h13.02v13.02H0z"
  })))));
};
export default SvgSearch;